"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberDisplay = exports.NumberDisplayContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const R = __importStar(require("ramda"));
const styled_components_1 = __importDefault(require("styled-components"));
const style_1 = __importDefault(require("style"));
const NumberContainer_1 = require("./NumberContainer");
exports.NumberDisplayContainer = (0, styled_components_1.default)(NumberContainer_1.NumberContainer) `
  ${style_1.default.Text.Definition.Subheader};
  height: ${R.prop('size')};
  width: ${R.prop('size')};
`;
const NumberDisplay = (props) => {
    const { value, onClick, size = style_1.default.Sizing.Size.Base } = props;
    return ((0, jsx_runtime_1.jsx)(exports.NumberDisplayContainer, Object.assign({ onClick: onClick, size: size }, { children: value })));
};
exports.NumberDisplay = NumberDisplay;
